import ServicesPanel from './services-panel';
import teamInit from './team';
import Icon from './icon';
import Nav from './nav';
import Carousel from './carousel';
import LocationsMap from './locations';
import Parallax from './parallax';

// Translations from WordPress
interface Translations {
	allEmployees: string;
	services: string;
	allServices: string;
	learnMore: string;
}
declare global {
	const wpTranslations: Translations | undefined;
	function _t(id: keyof Translations): string;
}
window._t = function(id) {
	if (typeof wpTranslations === 'undefined') return '';
	return wpTranslations[id] || '';
};

// Load icons
Icon.load();

// Declare nav
let nav: Nav;

// Fire when DOM is complete
window.addEventListener('DOMContentLoaded', () => {

	// Load nav
	nav = new Nav();

	// Create carousels
	document.querySelectorAll<HTMLElement>('[data-carousel]').forEach((carousel) => Carousel.create(carousel));

	// Init locations map
	document.querySelectorAll<HTMLElement>('#home-locations').forEach((map) => new LocationsMap(map));
	
});

// Fire when all other assets are loaded
window.addEventListener('load', () => {

	// Load carousels
	Carousel.load();

	// Load services panel
	new ServicesPanel(nav);

	// Load team grid if on team page
	if (document.body.classList.contains('page-template-team')) teamInit();

	// Load parallax effects
	Parallax.init();

});
